import { useTranslation } from "react-i18next";

import Button from "@/components/Button";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import useLocale from "@/hooks/useLocale";

const NotFound = () => {
  const { t } = useTranslation();
  const locale = useLocale();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-6 py-12 text-center relative">
      <div className="relative z-10 max-w-md mx-auto">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-blue leading-none">404</h1>
        </div>

        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            {t("notFound.title")}
          </h2>
          <p className="text-gray-600 leading-relaxed">
            {t("notFound.message")}
          </p>
        </div>

        <div className="space-y-4">
          <Button href={`/${locale}`}>{t("notFound.goHome")}</Button>
        </div>
      </div>
      <LanguageSwitcher />
    </div>
  );
};

export default NotFound;
